import React from "react";
import { STATUSES, formatDateTime } from "./feedbackRules";

/** Status chip of the feedback (New, In progress, Hotel updated, Resolved, Canceled). */
export function StatusChip({ statusId, label }) {
  const status = STATUSES[statusId] ?? STATUSES[1];
  return <span className={`fbk-status is-${status.tone}`}>{label || status.label}</span>;
}

/**
 * The feedback as a chat: the crew member's first message, then every reply in order. Crew messages sit on the left,
 * staff replies on the right with the status they set. Text only (never HTML from the app).
 */
export default function ConversationThread({ feedback }) {
  const messages = feedback.messages ?? [];
  return (
    <ol className="fbk-thread" aria-label="Conversation">
      <li className="fbk-msg is-crew">
        <div className="fbk-msg__bubble">
          <div className="fbk-msg__head">
            <strong>{feedback.crewName || feedback.employeeNumber || "Crew"}</strong>
            <span>{formatDateTime(feedback.createdAt)}</span>
          </div>
          <p className={feedback.description ? "" : "text-muted"}>{feedback.description || "No text, see the details."}</p>
        </div>
      </li>
      {messages.map((m) => (
        <li key={m.id} className={`fbk-msg ${m.isCrew ? "is-crew" : "is-staff"}`}>
          <div className="fbk-msg__bubble">
            <div className="fbk-msg__head">
              <strong>{m.byName || (m.isCrew ? "Crew" : "Staff")}</strong>
              <span>{formatDateTime(m.at)}</span>
            </div>
            <p>{m.message}</p>
            {m.photoUrl && (
              <a className="fbk-msg__photo" href={m.photoUrl} target="_blank" rel="noopener noreferrer">
                <i className="fas fa-image" aria-hidden="true" /> Photo
              </a>
            )}
            {!m.isCrew && m.statusId > 0 && (
              <div className="fbk-msg__status">
                <StatusChip statusId={m.statusId} label={m.statusName} />
              </div>
            )}
          </div>
        </li>
      ))}
      {messages.length === 0 && (
        <li className="fbk-thread__empty">
          <i className="far fa-comments" aria-hidden="true" /> No reply yet.
        </li>
      )}
    </ol>
  );
}
